import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

const activeMarkerSelector = (state: AppState) => state.frontendState.activeMapElements.activeMarker;
const activeMarkerNavigationIndexSelector = (state: AppState) => state.frontendState.activeMapElements.activeMarkerNavigationIndex;
export const activeMarkerIdsSelector = (state: AppState) => state.frontendState.activeMapElements.activeMarker?.rowIds;
export const activeOverlappingElementsSelector = (state: AppState) => state.frontendState.activeMapElements.activeOverlappingElements;
export const activeOverlappingLocationSelector = (state: AppState) => activeOverlappingElementsSelector(state).activeOverlappingLocation;
const activeMarkerIdSelector = (state: AppState) => activeMarkerIdsSelector(state)?.[
  state.frontendState.activeMapElements.activeMarkerNavigationIndex
];
export const useActiveMarkerSelector = () => useSelector(activeMarkerSelector);
export const useActiveMarkerNavigationIndexSelector = () => useSelector(activeMarkerNavigationIndexSelector);
export const useActiveMarkerIdSelector = () => useSelector(activeMarkerIdSelector);
export const useActiveMarkerIdsSelector = () => useSelector(activeMarkerIdsSelector);
export const useActiveOverlappingElementsSelector = () => useSelector(activeOverlappingElementsSelector);

const hoveredMarkerSelector = (state: AppState) => state.frontendState.activeMapElements.hoveredMarker;
export const useHoveredMarkerSelector = () => useSelector(hoveredMarkerSelector);

export const activeBoundarySelector = (state: AppState) => state.frontendState.activeMapElements.activeBoundary;
export const useActiveBoundarySelector = () => useSelector(activeBoundarySelector);

export const activeBoundaryTerritorySelector = (state: AppState) => state.frontendState.activeMapElements.activeBoundaryTerritory;
export const useActiveBoundaryTerritorySelector = () => useSelector(activeBoundaryTerritorySelector);

export const activeProximitySelector = (state: AppState) => state.frontendState.activeMapElements.activeProximity;
export const useActiveProximitySelector = () => useSelector(activeProximitySelector);
const hoveredProximitySelector = (state: AppState) => state.frontendState.activeMapElements.hoveredProximity;
export const useHoveredProximitySelector = () => useSelector(hoveredProximitySelector);

const isLocationListOpen = (state: AppState) => state.frontendState.activeMapElements.isLocationListActive;
export const useIsLocationListOpen = () => useSelector(isLocationListOpen);

export const activePlaceStateSelector = (state: AppState) => state.frontendState.activeMapElements.activePlace;

const isMasterKeyActive = (state: AppState) => state.frontendState.activeMapElements.isMasterKeyActive;
export const useIsMasterKeyActive = () => useSelector(isMasterKeyActive);

const isMapKeyPanelOpen = (state: AppState) => isLocationListOpen(state) || isMasterKeyActive(state);
export const useIsMapKeyPanelOpen = () => useSelector(isMapKeyPanelOpen);

const spreadsheetPreviewFilterStateSelector = (state: AppState) => state.frontendState.activeMapElements.spreadsheetPreviewFilterState;
export const useSpreadsheetPreviewFilterStateSelector = () => useSelector(spreadsheetPreviewFilterStateSelector);
